// frontend/src/utils/brandingApi.js
import crmApi from './crmApi';
import axios from 'axios';

// Public branding API (no auth required)
const publicBrandingApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const brandingAPI = {
  // Get branding settings for current user/agency (requires auth)
  getBranding: (agencyId = null) => {
    const config = {};
    if (agencyId) {
      config.headers = {
        'x-agency-id': String(agencyId)
      };
    }
    return crmApi.get('/branding', config);
  },
  
  // Get public branding by domain or agencyId (no auth required)
  getPublicBranding: async (agencyId = null, domain = null) => {
    const params = new URLSearchParams();
    if (agencyId) params.append('agencyId', agencyId);
    if (domain) params.append('domain', domain);
    
    const response = await publicBrandingApi.get(`/public/branding?${params.toString()}`);
    return response;
  },
  
  // Update branding settings
  updateBranding: (data) => crmApi.put('/branding', data),
  
  // Update specific branding field
  updateField: (field, value) => crmApi.patch('/branding/field', { field, value }),
  
  // Upload branding image
  uploadImage: (type, file) => {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('type', type);
    return crmApi.post('/branding/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  // Delete branding image
  deleteImage: (type) => crmApi.delete(`/branding/image/${type}`),
  
  // Reset branding to defaults
  resetBranding: () => crmApi.post('/branding/reset'),
};

export default brandingAPI;
